import { PAGE_ANALYTICS_INFO } from '../page-types'

/* ------- MICROFRONT - COMMANDE FLASH ------- */

export const flashOrderRoutes = [
  {
    path: '/flash-order',
    name: 'flash-order',
    component: () => import('@b2ag/micro-front-flash-order/app'),
    props: () => ({
      microFrontName: 'flash-order',
      viewName: 'default',
    }),
    meta: {
      private: true,
      noMainPadding: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.FLASH_ORDER,
    },
  },
]
